import { Shell } from "@/shell/Shell";
import { PageHeader } from "@/shell/PageHeader";
import { ExperimentalDashboard } from "@/features/orders-analytics/components/ExperimentalDashboard";
import { FiltersBar } from "@/features/orders-analytics/components/FiltersBar";
import { useOrdersAnalyticsData } from "@/features/orders-analytics/hooks/use-orders-analytics-data";
import { useOrdersAnalyticsFilters } from "@/features/orders-analytics/hooks/use-orders-analytics-filters";
import { timezone } from "@/features/orders-analytics/utils/timezone";

export function ExperimentalPage() {
    const { filters, setFilters } = useOrdersAnalyticsFilters();
    const todayStart = timezone.getTimeZoneDayStartTimestamp(Date.now());
    const {
        data,
        loading,
        isFetching,
        refresh,
    } = useOrdersAnalyticsData(filters, "client", todayStart, null, null);

    return (
        <Shell title="Experimental" subtitle="R&D dashboards">
            <PageHeader
                title="Experimental"
                lede="Prototype views and exploratory metrics. Not production-stable."
                right={
                    <FiltersBar
                        filters={filters}
                        availableClients={data.availableClients}
                        onFiltersChange={setFilters}
                        onRefresh={refresh}
                        loading={loading || isFetching}
                    />
                }
            />

            <ExperimentalDashboard
                filters={filters}
                summary={data.summary}
                trends={data.trends}
                today={data.today}
                funnel={data.funnel}
                performance={data.performance}
                monetization={data.monetization}
                quality={data.quality}
                segmentation={data.segmentation}
                customers={data.customers}
            />
        </Shell>
    );
}
